<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KmYdRW/tc-custom/9781554909773.jpg?1734290702720" alt="This image is the cover for the book Cherry Beach Express, The Steve Nastos Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cherry Beach Express, The Steve Nastos Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A police detective is accused of murder in this novel that “delivers on all levels: action, courtroom drama . . . and a show-stopping climax” (<i>The Hamilton Spectator</i>).</b><br/>  <br/> Until recently, Steve Nastos was a respected Toronto detective, part of the sexual assault unit. Now he’s in custody—accused of killing his young daughter’s dentist after learning of the man’s unspeakable crimes against children.<br/>  <br/> Freed on bail, he has one hope: to track down the actual killer, in a town where laws are seen more as guidelines and law enforcement agents adhere to their own moral relativism. Handicapped by a recovering alcoholic lawyer, a rogue cop, and a two-faced judge, Nastos has the cards stacked against him. Then his estranged but still beloved wife inadvertently becomes involved in the case, and the stakes become even higher.<br/>  <br/> He has to protect his family—but first he has to save himself . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.D. Cain
      </h2>
      
      <p class="authorDescription body article"><B>R.D. Cain</B> has worked for the last 18 years in the emergency services as a paramedic, firefighter, and police officer. He lives in Scarborough, Ontario.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ECW Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f812ec94